export const ELEMENT_INDEX = {
    FIRST: 0,
    SECOND: 1,
    THIRD: 2,
    FOURTH: 3,
    FIFTH: 4,
    SIXTH: 5,
    SEVENTH: 6,
    EIGHTH: 7,
    NINTH: 8,
    TENTH: 9,
};

export const INDEX_COUNT = {
    ONE: 1,
    TWO: 2,
};

export const APP_ROUTES = {
    MAIN: '/',
    NEWS: '/news',
    CONTACTS: '/contacts',
    ABOUT_US: '/about-us',
    INDUSTRIES: '/industries',
    SOLUTIONS: '/solutions',
    PRODUCTS: '/products',
    SERVICES: '/services',
    PROJECTS: '/projects',
    PLATFORM: '/monitoring-platform',
} as const;

export const GLOBAL_LABELS = {
    HOME: 'Home',
} as const;

export const ARRAY_LENGTH = {
    ONE: 1,
    TWO: 2,
} as const;

export const GENERAL_URL: string = `${process.env.NEXT_PUBLIC_BASE_URL!}/api`;

export const STATUS_CODE = {
    SUCCESS: 200,
};

export const ACCESS_TOKEN_LOCAL_STORAGE_KEY = 'sessionBlob19231Q';

export const PRIVACY_POLICE = [
    {
        title: '1. Introduction',
        description: [
            'Welcome to EDJR. Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website edjr-tracking.com. By using our website, you consent to the data practices described in this Privacy Policy.',
        ],
    },
    {
        title: '2. Information We Collect',
        description: [
            'We may collect and process the following types of information:',
            'Personal Information: This includes information that can be used to identify you, such as your name, email address, phone number, mailing address, and any other details you provide when contacting us, signing up for an account, or subscribing to our services.',
            'Non-Personal Information: We may automatically collect information about your interactions with our website, including your browser type, IP address, device type, geographical location, and browsing behavior.',
            'Cookies and Tracking Technologies: We use cookies and similar tracking technologies to enhance user experience, analyze website traffic, and personalize content. You can modify your browser settings to manage or disable cookies.',
        ],
    },
    {
        title: '3. How We Use Your Information',
        description: [
            'We may use your information for the following purposes:',
            'To provide, operate, and maintain our website and services.',
            'To improve and personalize your user experience.',
            'To communicate with you, including responding to inquiries, sending customer support messages, and providing updates.',
            'To send you promotional communications, special offers, and newsletters if you have opted in to receive them.',
            'To monitor website performance and analyze trends to enhance our services.',
            'To comply with legal obligations and protect against fraud or unauthorized activity.',
        ],
    },
    {
        title: '4. Sharing of Information',
        description: [
            'We do not sell, trade, or rent your personal information. However, we may share your data with:',
            'Service Providers: Third-party companies that assist us in operating our website, processing transactions, or providing analytics.',
            'Legal and Regulatory Authorities: If required by law, we may disclose your information to comply with legal proceedings, enforce our policies, or protect our rights and safety.',
            'Business Transfers: In the event of a merger, acquisition, or sale of assets, your data may be transferred to the new entity.',
            'Third Parties with Your Consent: If you provide explicit consent, we may share your information with third parties for specific purposes.',
        ],
    },
    {
        title: '5. Data Security',
        description: [
            'We take reasonable measures to protect your personal data from unauthorized access, loss, misuse, or alteration. These measures include encryption, secure servers, and access controls. However, no data transmission over the Internet is completely secure, and we cannot guarantee absolute security.',
        ],
    },
    {
        title: '6. Your Rights and Choices',
        description: [
            'Depending on your location, you may have the following rights regarding your personal data:',
            'Access and Correction: You can request access to your personal information and request corrections if necessary.',
            'Data Deletion: You have the right to request the deletion of your personal data, subject to legal and contractual obligations.',
            'Opt-Out: You can opt out of receiving marketing communications at any time by following the unsubscribe instructions in our emails or contacting us directly.',
            'Cookie Management: You can manage or disable cookies through your browser settings.',
        ],
    },
    {
        title: '7. Third-Party Links',
        description: [
            'Our website may contain links to third-party websites. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies before providing any personal information.',
        ],
    },
    {
        title: '8. International Data Transfers',
        description: [
            'If you are accessing our website from outside Philippines, your information may be transferred to and processed in a country with different data protection laws. By using our website, you consent to such transfers.',
        ],
    },
    {
        title: '9. Children\'s Privacy',
        description: [
            'Our website is not intended for children under the age of 13. We do not knowingly collect or solicit personal information from minors. If we become aware that a child has provided us with personal data, we will take steps to remove the information promptly.',
        ],
    },
    {
        title: '10. Changes to This Privacy Policy',
        description: [
            'We may update this Privacy Policy from time to time to reflect changes in legal requirements, our practices, or technological advancements. Any updates will be posted on this page with an updated effective date. We encourage you to review this policy periodically.',
        ],
    },
    {
        title: '11. Contact Us',
        description: [
            'If you have any questions about this Privacy Policy, please contact us at:',
            'Email: edjr23deloria@gmail.com',
            'Address: Blk.4 Delta St. Greensville 1, Brngy Estefania, Bacolod City, Philippines.',
            'Phone: +63 998 550-97-38',
        ],
    },
];
